import React from 'react'
import styled from '@emotion/styled'
import { Locale, Translation } from 'locale'
import { UserPreference } from 'api'
import * as constants from 'view/styles/constants'
import * as mixins from 'view/styles/mixins'
import { iconSet } from 'view/components/icons'
import {
  ItemLabelContainer,
  ListContainer,
  ListItem,
  RemoveItemButton,
  BorderColourType
} from 'view/routes/staging/SendRFQPanel/rfqPanelStyles'
import { getAssetDescription } from 'view/routes/staging/SendRFQPanel/rfqPanelUtils'
import { CollapsePanel } from 'view/components/panels'
import { PreparedStagingOrder } from 'store/selection/selectionTypes'

interface AssetsSectionProps {
  readOnly: boolean
  selectedOrders: PreparedStagingOrder[]
  userPreference: UserPreference
  onRemoveAsset: (orderIds: string[]) => unknown
}

const ContentWrapper = styled.div`
  width: 100%;
  height: auto;
  min-height: 50px;
  padding: 17px 12px;
`

const OverwriteWarning = styled.div`
  label {
    font-weight: ${constants.FontWeight.Bold};
  }
  padding-bottom: 8px;
  font-size: 12px;
`

const OverwriteWarningIcon = styled.div`
  ${mixins.flexCenterContent}
  width: 10px;
  height: 10px;
  border-radius: 6px;
  color: ${constants.CORE_PRIMARY};
  font-size: 10px;
  background-color: #f5a623;
  margin-right: 6px;
`

export class AssetsSection extends React.Component<AssetsSectionProps> {
  render() {
    const { readOnly, selectedOrders } = this.props

    const overwrittenAssets = selectedOrders.filter(selectedOrder => selectedOrder.willOverwrite)
    return (
      <CollapsePanel
        title={Locale.translate(Translation.TC_ASSETS)}
        subtitle={`${this.props.selectedOrders.length} selected`}
        defaultCollapsed={false}>
        <ContentWrapper>
          {overwrittenAssets.length > 0 && (
            <OverwriteWarning>
              <label>{Locale.translate(Translation.SC_ASSETS_OVERWRITE_WARNING_COUNT, { assets: overwrittenAssets.length })}</label>
              {readOnly
                ? Locale.translate(Translation.SC_ASSETS_OVERWRITE_READONLY_WARNING_MESSAGE, { assets: overwrittenAssets.length })
                : Locale.translate(Translation.SC_ASSETS_OVERWRITE_WARNING_MESSAGE, { assets: overwrittenAssets.length })}
            </OverwriteWarning>
          )}
          <ListContainer>{this.getAssetItems()}</ListContainer>
        </ContentWrapper>
      </CollapsePanel>
    )
  }

  private getAssetItems = () => {
    const { readOnly, selectedOrders, userPreference } = this.props

    return selectedOrders.map((selectedOrder, idx: number) => {
      const orderId = selectedOrder.orderDetail.order.orderId
      return (
        <ListItem key={orderId} borderColourType={BorderColourType.Asset} index={idx}>
          <ItemLabelContainer>
            {selectedOrder.willOverwrite && <OverwriteWarningIcon>!</OverwriteWarningIcon>}
            {getAssetDescription(selectedOrder.orderDetail, userPreference)}
          </ItemLabelContainer>
          {!readOnly && <RemoveItemButton onClick={() => this.props.onRemoveAsset([orderId])}>{iconSet.crossIcon}</RemoveItemButton>}
        </ListItem>
      )
    })
  }
}
